export const tourneyMechanics = ['Highest Multiplier', 'Sum of all multipliers', 'Total Bet Amount', 'Total Spin Number', 'Total Win Amount']
